import {ICommandLineInterface} from '@gongxigames/framework/core/types';

export class BrowserConsoleInterface implements ICommandLineInterface {
    protected window: any;

    constructor() {
        this.window = window as any;
    }

    addCommand(name: string, callback: Function | Record<string, Function>): void {
        this.window[name] = callback;
    }

    removeCommand(name: string): void {
        if (this.window[name]) {
            delete this.window[name];
            this.window[name] = undefined;
        }
    }
}
